import { render, staticRenderFns } from "./AtsStages.html?vue&type=template&id=1fb903a8&scoped=true&external"
import script from "./AtsStages.js?vue&type=script&lang=js&external"
export * from "./AtsStages.js?vue&type=script&lang=js&external"
import style0 from "./AtsStages.scss?vue&type=style&index=0&id=1fb903a8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb903a8",
  null
  
)

export default component.exports